<template>
  <transition name="hc-profile-toast">
    <div
      v-if="visible"
      class="hc-profile-toast"
      :class="`hc-profile-toast--${variant}`"
      role="status"
      aria-live="polite"
    >
      <span class="hc-profile-toast__icon" aria-hidden="true">
        <svg v-if="variant === 'success'" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
          <path d="M8 12.5l2.5 2.5L16 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <svg v-else-if="variant === 'danger'" width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
          <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
          <path d="M12 8v5M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </span>
      <p class="hc-profile-toast__message">{{ message }}</p>
      <button
        type="button"
        class="hc-profile-toast__dismiss"
        aria-label="Dismiss notification"
        @click="hide"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ProfileToast',
  data() {
    return {
      visible: false,
      message: '',
      variant: 'success',
      timer: null,
      onClose: null,
    };
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    show(message, variant = 'success', options = {}) {
      this.clearTimer();
      this.message = message;
      this.variant = variant;
      this.onClose = typeof options.onClose === 'function' ? options.onClose : null;
      this.visible = true;

      const duration = options.duration ?? 3000;
      if (duration > 0) {
        this.timer = setTimeout(() => this.hide(), duration);
      }
    },
    hide() {
      this.clearTimer();
      if (!this.visible) return;
      this.visible = false;
      const callback = this.onClose;
      this.onClose = null;
      if (callback) callback();
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>
